import script from "./AdminAllCompanies.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminAllCompanies.vue?vue&type=script&setup=true&lang=js"

import "./AdminAllCompanies.vue?vue&type=style&index=0&id=7daa5570&scoped=true&lang=css"
import "./AdminAllCompanies.vue?vue&type=style&index=1&id=7daa5570&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7daa5570"]])

export default __exports__